import React from "react"
import LayoutDark from "../../components/LayoutDark"
import SEO from "../../components/Seo"
import Hero from "../../components/Services/OurTechnologies/Hero"
import Technologies from "../../components/Services/OurTechnologies/Technologies"

const OurTechnologies = () => {
  return (
    <LayoutDark>
      <SEO title="Our Technologies" />
      <Hero />
      <Technologies />
    </LayoutDark>
  )
}

export default OurTechnologies
